import { designSystemColors } from '@klv/shared/styles/colors';

import type { ISearchResultTheme } from '../../types';

const searchResult: ISearchResultTheme = {
  border: designSystemColors.sandShade,
  link: designSystemColors.charcoal,
  text: designSystemColors.charcoal,
};

export default searchResult;
